export const API_URL = 'http://localhost:8000';
export const DOCUMENTATION_URL = 'https://docs.quadratic.to';
export const BUG_REPORT_URL = 'https://github.com/quadratichq/quadratic/issues';
